import { PropsWithChildren } from "react";
import { isEmpty } from "lodash";
import useParameters from "@src/app/parameters/useParameter";

export default function ParameterProvider({ children }: PropsWithChildren) {
  const parameters = useParameters(); // preload parameters

  if (!parameters || isEmpty(parameters)) {
    return null;
  }

  return children;
}
